import React, { useState } from 'react';
import { Box, Drawer, List, ListItem, ListItemIcon, ListItemText, AppBar, Toolbar, Typography, Divider, Button } from '@mui/material';
import { Person, Business, Dashboard, Home } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import AdminUserManagement from './AdminUserManagement';
import AdminClientManagement from './AdminClientManagement';
import AdminOverview from './AdminOverview';

const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 0,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: drawerWidth,
    }),
  }),
);

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

const AdminDashboard = () => {
  const [selectedView, setSelectedView] = useState('overview');

  const renderContent = () => {
    switch (selectedView) {
      case 'users':
        return <AdminUserManagement />;
      case 'clients':
        return <AdminClientManagement />;
      case 'overview':
      default:
        return <AdminOverview />;
    }
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            StateShift Admin Dashboard
          </Typography>
          <Button 
            component={RouterLink}
            to="/"
            startIcon={<Home />}
            color="inherit"
            sx={{ ml: 2 }}
          >
            Back to Main
          </Button>
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
        variant="permanent"
        anchor="left"
      >
        <Toolbar />
        <Divider />
        <List>
          <ListItem button onClick={() => setSelectedView('overview')} selected={selectedView === 'overview'}>
            <ListItemIcon>
              <Dashboard />
            </ListItemIcon>
            <ListItemText primary="Dashboard Overview" />
          </ListItem>
          <ListItem button onClick={() => setSelectedView('users')} selected={selectedView === 'users'}>
            <ListItemIcon>
              <Person />
            </ListItemIcon>
            <ListItemText primary="User Management" />
          </ListItem>
          <ListItem button onClick={() => setSelectedView('clients')} selected={selectedView === 'clients'}>
            <ListItemIcon>
              <Business />
            </ListItemIcon>
            <ListItemText primary="Client Management" />
          </ListItem>
        </List>
      </Drawer>
      <Main>
        <DrawerHeader />
        {renderContent()}
      </Main>
    </Box>
  );
};

export default AdminDashboard;